import {
  ASSET_STATUS_LABELS,
  WORK_ORDER_STATUS_LABELS,
  type AssetStatus,
  type WorkOrderStatus,
} from '@wodi/domain';
import { Tag } from '@wodi/ui';

import { dayText } from '../operations/format.tsx';

// Asset and work order states as words on tags (DESIGN.md §7).

export function AssetStatusTag({ status }: { status: AssetStatus }) {
  const state =
    status === 'in_service' ? 'done' : status === 'out_of_service' ? 'failed' : 'neutral';
  return <Tag state={state}>{ASSET_STATUS_LABELS[status]}</Tag>;
}

export function WorkOrderStatusTag({ status }: { status: WorkOrderStatus }) {
  const state =
    status === 'open'
      ? 'pending'
      : status === 'in_progress'
        ? 'active'
        : status === 'completed'
          ? 'done'
          : 'neutral';
  return <Tag state={state}>{WORK_ORDER_STATUS_LABELS[status]}</Tag>;
}

/** "Due 14 Feb 2026" with an overdue or due-soon tag, or "No service planned". */
export function DueWords({
  nextServiceDue,
  dueState,
}: {
  nextServiceDue: string | null;
  dueState: 'overdue' | 'due_soon' | null;
}) {
  if (nextServiceDue === null) return <>No service planned</>;
  return (
    <>
      {dayText(nextServiceDue)}{' '}
      {dueState === 'overdue' ? <Tag state="attention">Overdue</Tag> : null}
      {dueState === 'due_soon' ? <Tag state="pending">Due soon</Tag> : null}
    </>
  );
}
